import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getDependenciasEmpleador } from "../../../../redux/actions/empleador";
import {
  clearPostRes, clearRes, clearSearchedEstablecimiento, getDatosEstablecimiento, getFormularioAnterior, getFormularioPorId, getFormulariosPresentados, postSearchedRes, validarDisponibilidadCargaResolucion
} from "../../../../redux/actions/resolucion";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import SearchEstablecimiento from "../../../commons/establecimiento/SearchEstablecimiento";
import EstablecimientoCard from "./cards/EstablecimientoCard";

const EstablecimientoContainer = ({ fromBread, nextForm, mapFormValues, handleCancelResolucion }) => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const searchedEstablecimiento = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  const dependenciasEmpleador = useSelector(
    (state) => state.empleador.dependenciasEmpleador
  );
  const postResolucion = useSelector(
    (state) => state.resolucion.postResolucion
  );

  const resolucionTieneDatos =
    Object.keys(postResolucion.cabecera).length > 0 ||
    Object.keys(postResolucion.observaciones).length > 0;

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [searchModel, setSearchModel] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [checked, setChecked] = useState(false);

  const isLoading = dependenciasEmpleador.loading;

  useEffect(() => {
    setSearchModel({ establecimiento: selectedValue, soloActivos: checked });
  }, [selectedValue, checked]);

  const getCards = (idEstablecimiento) => {
    dispatch(getDatosEstablecimiento(idEstablecimiento));
    dispatch(getFormulariosPresentados(idEstablecimiento));
  };

  useEffect(() => {
    // Caso carga inicial: (no pasa de nuevo al volver atras en el formulario)
    if (!fromBread) {
      dispatch(getDependenciasEmpleador()).then(() => {
        setSelectedValue(state?.idDependenciaEmpleador ?? searchedEstablecimiento ?? null)
      });
      dispatch(clearRes());
      if (state?.idDependenciaEmpleador) {
        dispatch(postSearchedRes(state.idDependenciaEmpleador));
        dispatch(getFormularioPorId(state.idFormulario)).then((data) => {
          mapFormValues(data)
        })
        getCards(state.idDependenciaEmpleador)
      }
    } else {
      setSelectedValue(searchedEstablecimiento);
    }
  }, [state, fromBread]);



  const handleSearch = (values) => {
    dispatch(clearPostRes());
    if (values?.establecimiento) {
      dispatch(postSearchedRes(values.establecimiento));
      dispatch(validarDisponibilidadCargaResolucion(values.establecimiento))
        .then(() => {
          dispatch(getFormularioAnterior(values.establecimiento)).then((data) => {
            mapFormValues(data)
          });
        });
      getCards(values.establecimiento);
    } else {
      dispatch(clearSearchedEstablecimiento());
    }
  };

  return (
    <>
      <SearchEstablecimiento
        options={dependenciasEmpleador.data}
        loading={isLoading}
        handleSearch={handleSearch}
        searchModel={searchModel}
        searched={searchedEstablecimiento}
        setOpenConfirmDialog={() => setOpenConfirmDialog(true)}
        setSelectedValue={setSelectedValue}
        setChecked={setChecked}
        hasDatosPost={resolucionTieneDatos}
        disabled={!!state?.idDependenciaEmpleador}
      />
      <EstablecimientoCard
        searchedRes={searchedEstablecimiento}
        nextForm={nextForm}
        handleCancelResolucion={handleCancelResolucion}
      />
      <ConfirmDialog
        open={openConfirmDialog}
        handleClose={() => {
          setOpenConfirmDialog(false);
          setSelectedValue(searchedEstablecimiento);
          setSearchModel({ establecimiento: searchedEstablecimiento });
        }}
        handleConfirm={() => {
          handleSearch({ establecimiento: selectedValue });
          setOpenConfirmDialog(false);
        }}
        title="Perderá todos los datos completados"
        warningText={
          "Al buscar otro establecimiento los datos cargados anteriormente se perderán."
        }
        loading={false}
      />
    </>
  );
};

export default EstablecimientoContainer;
